<div class="traffic-log-list-expanded-content-communicating-ips">
    <!-- 1st row -->
    <div class="traffic-log-list-expanded-content-communicating-ips__row">
        <!-- Client IP -->
        <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
            <div
                logFieldTitle
                [inline]="true"
            >
                {{ globalL10nKeys.clientIpLabel | vtranslate }}
            </div>
            <ng-container *ngrxLet="clientIps$ as clientIps">
                <ng-container *ngIf="clientIps.client_ip || clientIps.client_ip6; else noData">
                    <log-ip-field
                        *ngIf="clientIps.client_ip && !clientIps.client_ip6"
                        property="client_ip"
                        [ip]="clientIps.client_ip"
                        portProperty="client_src_port"
                        [port]="clientSrcPort$ | async"
                        [inline]="true"
                        [noSearchIcons]="true"
                    ></log-ip-field>

                    <log-ip-field
                        *ngIf="clientIps.client_ip6"
                        version="ipv6"
                        property="client_ip6"
                        [ip]="clientIps.client_ip6"
                        portProperty="client_src_port"
                        [port]="clientSrcPort$ | async"
                        [inline]="true"
                        [noSearchIcons]="true"
                    ></log-ip-field>
                </ng-container>
            </ng-container>
            <double-arrow
                class="traffic-log-list-expanded-content-communicating-ips__connection-arrow traffic-log-list-expanded-content-communicating-ips__bridge--long"
                color="green"
            ></double-arrow>
        </div>

        <!-- VS IP -->
        <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
            <div
                logFieldTitle
                [inline]="true"
            >
                {{ l10nKeys.virtualServiceIpLabel | vtranslate }}
            </div>
            <ng-container *ngrxLet="vsIps$ as vsIps">
                <ng-container *ngIf="vsIps.vs_ip || vsIps.vs_ip6">
                    <log-ip-field
                        *ngIf="vsIps.vs_ip && !vsIps.vs_ip6"
                        property="vs_ip"
                        [ip]="vsIps.vs_ip"
                        portProperty="client_dest_port"
                        [port]="clientDestPort$ | async"
                        [inline]="true"
                        [noSearchIcons]="true"
                    ></log-ip-field>
                    <log-ip-field
                        *ngIf="vsIps.vs_ip6"
                        version="ipv6"
                        property="vs_ip6"
                        [ip]="vsIps.vs_ip6"
                        portProperty="client_dest_port"
                        [port]="clientDestPort$ | async"
                        [inline]="true"
                        [noSearchIcons]="true"
                    ></log-ip-field>
                </ng-container>
                <span *ngIf="!vsIps.vs_ip && !vsIps.vs_ip6">
                    <!-- no filter here -->
                    {{ defaultVsIp$ | async }}
                </span>
            </ng-container>
        </div>
        <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
            <!-- intentionally left blank as a placeholder -->
        </div>
    </div>

    <!-- 2nd row -->
    <!-- IP field titles -->
    <div
        class="traffic-log-list-expanded-content-communicating-ips__row"
        *ngrxLet="vsAppProfileType$ as vsAppProfileType"
    >
        <ng-container *ngrxLet="pool$ as hasPool">
            <!-- Source Client IP -->
            <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
                <div
                    logFieldTitle
                    [inline]="true"
                    *ngIf="vsAppProfileType === VsAppProfileType.L7"
                >
                    {{ l10nKeys.sourceClientIpLabel | vtranslate }}
                </div>
                <ng-container *ngIf="vsAppProfileType === VsAppProfileType.L7">
                    <ng-container *ngrxLet="sourceIps$ as sourceIps">
                        <ng-container *ngIf="sourceIps.source_ip || sourceIps.source_ip6; else noData">
                            <log-ip-field
                                *ngIf="sourceIps.source_ip && !sourceIps.source_ip6"
                                property="source_ip"
                                [ip]="sourceIps.source_ip"
                                [inline]="true"
                                [noSearchIcons]="true"
                            ></log-ip-field>
                            <log-ip-field
                                *ngIf="sourceIps.source_ip6"
                                version="ipv6"
                                property="source_ip6"
                                [ip]="sourceIps.source_ip6"
                                [inline]="true"
                                [noSearchIcons]="true"
                            ></log-ip-field>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>

            <!-- Server Connection IP -->
            <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
                <ng-container *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool">
                    <div
                        logFieldTitle
                        [inline]="true"
                    >
                        {{ l10nKeys.serverConnectionIpLabel | vtranslate }}
                    </div>
                    <ng-container *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool">
                        <ng-container *ngrxLet="serverConnectionSrcIps$ as serverConnSrcIps">
                            <ng-container *ngIf="serverConnSrcIps.server_conn_src_ip || serverConnSrcIps.server_conn_src_ip6; else noData">
                                <log-ip-field
                                    *ngIf="serverConnSrcIps.server_conn_src_ip && !serverConnSrcIps.server_conn_src_ip6"
                                    property="server_conn_src_ip"
                                    [ip]="serverConnSrcIps.server_conn_src_ip"
                                    portProperty="server_src_port"
                                    [port]="serverSrcPort$ | async"
                                    [inline]="true"
                                    [noSearchIcons]="true"
                                ></log-ip-field>
                                <log-ip-field
                                    *ngIf="serverConnSrcIps.server_conn_src_ip6 as ip6"
                                    version="ipv6"
                                    property="server_conn_src_ip6"
                                    [ip]="ip6"
                                    portProperty="server_src_port"
                                    [port]="serverSrcPort$ | async"
                                    [inline]="true"
                                    [noSearchIcons]="true"
                                ></log-ip-field>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <double-arrow
                        class="traffic-log-list-expanded-content-communicating-ips__connection-arrow traffic-log-list-expanded-content-communicating-ips__bridge--long"
                        color="green"
                    ></double-arrow>
                </ng-container>
            </div>

            <!-- Server IP -->
            <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
                <div
                    logFieldTitle
                    [inline]="true"
                    *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool"
                >
                    {{ globalL10nKeys.serverIpLabel | vtranslate }}
                </div>
                <ng-container *ngIf="vsAppProfileType !== VsAppProfileType.DNS || hasPool">
                    <ng-container *ngrxLet="serverIps$ as serverIps">
                        <span
                            *ngIf="(poolName$ | async) as poolName"
                            logPartialSelectionFilter
                            [noSearchIcon]="true"
                            property="pool_name"
                            [value]="poolName"
                        ></span>
                        <ng-container *ngrxLet="serverName$ as serverName">
                            <ng-container *ngIf="serverName && serverName !== (serverIps.server_ip | toString)">
                                :<span
                                    logPartialSelectionFilter
                                    property="server_name"
                                    [value]="serverName"
                                    [noSearchIcon]="true"
                                ></span>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="serverIps.server_ip || serverIps.server_ip6">
                            (<log-ip-field
                                    *ngIf="serverIps.server_ip && !serverIps.server_ip6"
                                    property="server_ip"
                                    [ip]="serverIps.server_ip"
                                    portProperty="server_dest_port"
                                    [port]="serverDestPort$ | async"
                                    [noSearchIcons]="true"
                                    [inline]="true"
                                ></log-ip-field>
                                <log-ip-field
                                    *ngIf="serverIps.server_ip6 as ip6"
                                    version="ipv6"
                                    property="server_ip6"
                                    [ip]="ip6"
                                    portProperty="server_dest_port"
                                    [port]="serverDestPort$ | async"
                                    [noSearchIcons]="true"
                                    [inline]="true"
                                ></log-ip-field>
                            )
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
    </div>

    <!-- 3rd row -->
    <div class="traffic-log-list-expanded-content-communicating-ips__row">
        <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
            <!-- intentionally left blank as a placeholder -->
        </div>

        <!-- Service Engine -->
        <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
            <div
                logFieldTitle
                [inline]="true"
            >
                {{ globalL10nKeys.serviceEngineLabel | vtranslate }}
            </div>
            <div
                *ngrxLet="serviceEngine$ as serviceEngine"
                logPartialSelectionFilter
                [noSearchIcon]="true"
                property="service_engine"
                [value]="serviceEngine"
            ></div>
            &nbsp;(vcpu:
            <span
                *ngrxLet="vcpuId$ as vcpuId"
                logFilter
                [property]="'vcpu_id'"
                [value]="vcpuId"
            >
                {{ vcpuId }}
            </span>)
        </div>
        <div class="traffic-log-list-expanded-content-communicating-ips__row-col">
            <!-- intentionally left blank as a placeholder -->
        </div>
    </div>
</div>

<ng-template #noData>
    <span logEmptyField></span>
</ng-template>
